import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import DownloadPopup from "../App/DownloadPopup";
import DragDrop from "../DragDrop/DragDrop";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { useGlobalState } from "../Context/GlobalStateContext";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import LockUnlock from "../App/LockUnlock";
import TabFilter from "../App/TabFilter";
import { DownloadClientsDataInExcel, getAccessSettings } from "../Shared/Utility";
function AccessLevel() {
  const globalState = useGlobalState();

  const thStyle: any = {
    transform: "rotate(270deg)",
    height: "200px",
    whiteSpace: "nowrap",
    textAlign: "center",
    padding: "5px",
    width: "5px",
  };

  const [showAnimation, setShowAnimation] = useState(false);
  const [dealerID, setDealerID] = useState(0);
  const [AccessLevelData, setAccessLevelData] = useState<any>([]);

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully!"
  );
  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 1,
    MaxAllowedFiles: 1,
    UploadType: 4,
    FolderName: "BP",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [locked, setLocked] = useState(true);

  let filterArray = [
    {
      Name: "Functional Level Access",
      ID: 1,
      Title: "Functional Level Access",
    },
    { Name: "Screen Level Access", ID: 2, Title: "Screen Level Access" },
    { Name: "Email Notifications", ID: 3, Title: "Email Notifications" },
  ];

  const [tabFilterObject, setTabFilterObject] = useState({
    AccessType: 1,
  });

  useEffect(() => {
    getUserApplicationSettingsData(0);
  }, [dealerID]);

  function handleTabFilterCallback(TabFilterData: any) {
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    if (Type === 1) {
      tabFilterObject.AccessType = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        AccessType: ID,
      }));
      getUserApplicationSettingsData(0);
    }
  }

  function getUserApplicationSettingsData(download: number) {
    setShowAnimation(true);
    let object = {} as any;
    object.appid = AppContext.App;
    object.accesstype = tabFilterObject.AccessType;
    object.dealerid = dealerID;
    object.download = download;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/GetUserApplicationSettingsDataIBB",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          console.log(l_response);
          const deepCopy1 = JSON.parse(JSON.stringify(l_response));
          const deepCopy2 = JSON.parse(JSON.stringify(l_response));
          setThisGridListDataWithoutFilters(deepCopy1);
          setAccessLevelData(deepCopy2);
          setThisGridListData(deepCopy2[1]);
          thisGridListDataRef.current = deepCopy2[1];
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function downloadUserApplicationSettingsData(download: number) {
    setShowAnimation(true);
    let object = {} as any;
    object.appid = AppContext.App;
    object.accesstype = tabFilterObject.AccessType;
    object.dealerid = dealerID;
    object.download = download;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/GetUserApplicationSettingsDataIBB",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setPopUpMessage("Data has been exported to file successfully!");
            setShowPopUp(true);
          }
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(
    value: any,
    colName: any,
    email: any,
    index: any,
    dataindex: any,
    colnameaccess: any,
    colName2: any
  ) {
    let l_GridData: any = [...AccessLevelData];
    l_GridData[index][dataindex][colName] = value;
    setAccessLevelData(l_GridData);

    saveAccessLevelData(email, value, colName2, colnameaccess);
  }

  function saveAccessLevelData(
    email: any,
    value: any,
    colname: any,
    colnameaccess: any
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.accesstype = tabFilterObject.AccessType;
    object.email = email;
    object.value = value;
    object.colname = colname;
    object.colnameaccess = colnameaccess;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/SaveUserApplicationSettingsDataIBB",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          // getUserApplicationSettingsData(0);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function SaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.sc = 0;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            savedBulkFactorsData(l_response);
          } else {
            globalState.setNotificationObject({
              ShowPopup: true,
              Heading: "Alert",
              Message: response.data.Message,
            });
            setShowAnimation(false);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
    }
  }

  function savedBulkFactorsData(p_S3UploadFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.filesdata = p_S3UploadFileList;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/GetSavedBulkUserApplicationSettingsDataIBB",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].LogFile;
          if (l_response[0][0].Status === 1) {
            let DisplayMessage =
              "Data has been imported. <br> Number of records: " +
              l_response[0][0].TotalRecords +
              "<br> Error in records: " +
              l_response[0][0].ErrorRecords;
            setPopUpMessage(DisplayMessage);
            setPopUpFileURL(link);
            setShowPopUp(true);
            getUserApplicationSettingsData(0);
          } else {
            globalState.setNotificationObject({
              ShowPopup: true,
              Heading: "Alert",
              Message: l_response[0][0].Message,
            });
          }
        } else {
          globalState.setNotificationObject({
            ShowPopup: true,
            Heading: "Alert",
            Message: response.data.Message,
          });
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [...AccessLevelData] as any;
    l_data[1] = [...FilterData];

    setAccessLevelData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setAccessLevelData(deepCopy);
    setThisGridListData(deepCopy[1]);
    thisGridListDataRef.current = deepCopy[1];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />
      <div className="page--contents">
        <div className="page--breadcrumb">
          {/* <a className="f-child">Admin</a>
          <span>{">"}</span> */}
          <a>Access Level</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items justify-btw">
              <div className="centre-drop-cl">
                <select
                  className="input-field select-field"
                  value={dealerID}
                  onChange={(e: any) => {
                    setDealerID(e.target.value);
                  }}
                >
                  <option value={0}>All Brands</option>
                  {AccessLevelData[0] &&
                    AccessLevelData[0].map((Item: any, index: any) => (
                      <option value={Item.PFIDealerID} key={index}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <TabFilter
                  DataType={1}
                  SelectedValue={tabFilterObject.AccessType}
                  DataList={filterArray}
                  TabFilterCallback={handleTabFilterCallback}
                />

                {!locked && (
                  <>
                    <div className="drad-drop">
                      <DragDrop
                        ParentFeatures={dragDropFeatures}
                        DragDropCallback={handleDragDropCallback}
                        TriggerChild={triggerChild}
                      />
                    </div>
                    <div className="flex-items msg-item"></div>
                    <div className="help-btns">
                      <a onClick={() => SaveFiles()}>Import Data</a>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="flex-items flex-33 justify-end">
              <a className="download-input" onClick={() => ClearAllFilters()}>
                Clear All Filters
              </a>

              {!locked && (
                <a
                  className="btn-primary btn-vols btn-vols-jlr"
                  onClick={() => downloadUserApplicationSettingsData(1)}
                >
                  Download Input File
                </a>
              )}

              {getAccessSettings(2, 23) > 1 && (
                <LockUnlock locked={locked} setLocked={setLocked} />
              )}
            </div>
            <a
                className="btn-primary no-display"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblaccesslevel", "ACCESS LEVEL")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
          </div>

          <>
            <div className="section-table scroll-table uv-vol dark-back courtesy-table fp-table access-table input-table access-level-table">
              {AccessLevelData[1] && (
                <ColumnFilterCheckboxList
                  DataType={1}
                  RefreshFilters={refreshFilters}
                  ClearFilters={clearFilters}
                  GridData={AccessLevelData[1]}
                  ColumnName={selectedColumnName}
                  ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                  GetFilteredLists={getFilteredLists}
                  ReturnAllFilterdLists={{}}
                  ClickPosition={clickPosition}
                  Orientation={"Center"}
                  ColumnOrientation={[
                    { Name: "FirstName", Orientation: "Right" },
                  ]}
                />
              )}

              {tabFilterObject.AccessType == 1 && (
                <table className="part-head trend-table" id="tblaccesslevel">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>

                      {AccessLevelData[3] &&
                        AccessLevelData[3].map((Item: any, index: any) => (
                          <th colSpan={2}>{Item.Name}</th>
                        ))}
                    </tr>
                    <tr className="JLRBold">
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          First Name
                        </span>
                      </th>
                      <th>
                        {" "}
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "LastName")}
                          data-function="ShowColumnFilterList"
                        >
                          Last Name
                        </span>
                      </th>
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "Email")}
                          data-function="ShowColumnFilterList"
                        >
                          Email
                        </span>
                      </th>

                      {AccessLevelData[3] &&
                        AccessLevelData[3].map((Item: any, index: any) => (
                          <>
                            <th>
                              <span>Access</span>
                            </th>
                            <th>
                              <span>Email</span>
                            </th>
                          </>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map(
                        (FirstItem: any, FirstIndex: any) => (
                          <React.Fragment key={"First" + FirstIndex}>
                            {!FirstItem.IsExcluded && (
                              <tr>
                                <td>{FirstItem.FirstName}</td>
                                <td className="text-left-m">
                                  {FirstItem.LastName}
                                </td>
                                <td className="text-left-m">
                                  {FirstItem.Email}
                                </td>

                                {AccessLevelData[3] &&
                                  AccessLevelData[3].map(
                                    (SecondItem: any, Secondindex: any) => (
                                      <>
                                        {AccessLevelData[2] &&
                                          AccessLevelData[2].map(
                                            (
                                              ThirdItem: any,
                                              Thirdindex: any
                                            ) => (
                                              <>
                                                {ThirdItem.ObjectID ==
                                                  SecondItem.ObjectID &&
                                                  ThirdItem.SiteUserID ==
                                                    FirstItem.SiteUserID && (
                                                    <>
                                                      <td>
                                                        <select
                                                          disabled={locked}
                                                          className="input-field select-field"
                                                          value={
                                                            ThirdItem.AccessStatus
                                                          }
                                                          onChange={(
                                                            e: any
                                                          ) => {
                                                            updateValue(
                                                              e.target.value,
                                                              "AccessStatus",
                                                              FirstItem.Email,
                                                              2,
                                                              Thirdindex,
                                                              "access",
                                                              SecondItem.Name
                                                            );
                                                          }}
                                                        >
                                                          <option value={0}>
                                                            No Access
                                                          </option>
                                                          <option value={1}>
                                                            Read Only
                                                          </option>
                                                          <option value={2}>
                                                            Read Write
                                                          </option>
                                                        </select>
                                                      </td>

                                                      <td>
                                                        <select
                                                          disabled={locked}
                                                          className="input-field select-field"
                                                          value={
                                                            ThirdItem.EmailStatus
                                                          }
                                                          onChange={(
                                                            e: any
                                                          ) => {
                                                            updateValue(
                                                              e.target.value,
                                                              "EmailStatus",
                                                              FirstItem.Email,
                                                              2,
                                                              Thirdindex,
                                                              "email",
                                                              SecondItem.Name
                                                            );
                                                          }}
                                                        >
                                                          <option value={0}>
                                                            No
                                                          </option>
                                                          <option value={1}>
                                                            Yes
                                                          </option>
                                                        </select>
                                                      </td>
                                                    </>
                                                  )}
                                              </>
                                            )
                                          )}
                                      </>
                                    )
                                  )}
                              </tr>
                            )}
                          </React.Fragment>
                        )
                      )}
                  </tbody>
                </table>
              )}

              {tabFilterObject.AccessType == 2 && (
                <table className="part-head trend-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>

                      {AccessLevelData[3] &&
                        AccessLevelData[3].map((Item: any, index: any) => (
                          <th colSpan={Item.PagesCount}>{Item.Section}</th>
                        ))}
                    </tr>
                    <tr className="JLRBold">
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          First Name
                        </span>
                      </th>
                      <th>
                        {" "}
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "LastName")}
                          data-function="ShowColumnFilterList"
                        >
                          Last Name
                        </span>
                      </th>
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "Email")}
                          data-function="ShowColumnFilterList"
                        >
                          Email
                        </span>
                      </th>

                      {AccessLevelData[3] &&
                        AccessLevelData[3].map(
                          (MainItem: any, Mainindex: any) => (
                            <>
                              {AccessLevelData[4] &&
                                AccessLevelData[4].map(
                                  (Item: any, index: any) => (
                                    <>
                                      {MainItem.PFIPageSectionID ==
                                        Item.PFIPageSectionID && (
                                        <th>
                                          <span>{Item.Name}</span>
                                        </th>
                                      )}
                                    </>
                                  )
                                )}
                            </>
                          )
                        )}
                    </tr>
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map(
                        (FirstItem: any, FirstIndex: any) => (
                          <React.Fragment key={"First" + FirstIndex}>
                            {!FirstItem.IsExcluded && (
                              <tr>
                                <td>{FirstItem.FirstName}</td>
                                <td className="text-left-m">
                                  {FirstItem.LastName}
                                </td>
                                <td className="text-left-m">
                                  {FirstItem.Email}
                                </td>

                                {AccessLevelData[4] &&
                                  AccessLevelData[4].map(
                                    (SecondItem: any, Secondindex: any) => (
                                      <>
                                        {AccessLevelData[2] &&
                                          AccessLevelData[2].map(
                                            (
                                              ThirdItem: any,
                                              Thirdindex: any
                                            ) => (
                                              <>
                                                {ThirdItem.ObjectID ==
                                                  SecondItem.ObjectID &&
                                                  ThirdItem.SiteUserID ==
                                                    FirstItem.SiteUserID && (
                                                    <>
                                                      <td>
                                                        <select
                                                          disabled={locked}
                                                          className="input-field select-field"
                                                          value={
                                                            ThirdItem.AccessStatus
                                                          }
                                                          onChange={(
                                                            e: any
                                                          ) => {
                                                            updateValue(
                                                              e.target.value,
                                                              "AccessStatus",
                                                              FirstItem.Email,
                                                              2,
                                                              Thirdindex,
                                                              "access",
                                                              SecondItem.Name
                                                            );
                                                          }}
                                                        >
                                                          <option value={0}>
                                                            No Access
                                                          </option>
                                                          <option value={1}>
                                                            Read Only
                                                          </option>
                                                          <option value={2}>
                                                            Read Write
                                                          </option>
                                                        </select>
                                                      </td>
                                                    </>
                                                  )}
                                              </>
                                            )
                                          )}
                                      </>
                                    )
                                  )}
                              </tr>
                            )}
                          </React.Fragment>
                        )
                      )}
                  </tbody>
                </table>
              )}

              {tabFilterObject.AccessType == 3 && (
                <table className="part-head trend-table">
                  <thead>
                    <tr className="JLRBold">
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          First Name
                        </span>
                      </th>
                      <th>
                        {" "}
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "LastName")}
                          data-function="ShowColumnFilterList"
                        >
                          Last Name
                        </span>
                      </th>
                      <th>
                        <span
                          className="c-pointer"
                          onClick={(e) => ShowColumnFilterList(e, "Email")}
                          data-function="ShowColumnFilterList"
                        >
                          Email
                        </span>
                      </th>
                      <>
                        {AccessLevelData[3] &&
                          AccessLevelData[3].map((Item: any, index: any) => (
                            <>
                              <th>
                                <span>{Item.Name}</span>
                              </th>
                            </>
                          ))}
                      </>
                    </tr>
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map(
                        (FirstItem: any, FirstIndex: any) => (
                          <React.Fragment key={"First" + FirstIndex}>
                            {!FirstItem.IsExcluded && (
                              <tr>
                                <td>{FirstItem.FirstName}</td>
                                <td className="text-left-m">
                                  {FirstItem.LastName}
                                </td>
                                <td className="text-left-m">
                                  {FirstItem.Email}
                                </td>

                                {AccessLevelData[3] &&
                                  AccessLevelData[3].map(
                                    (SecondItem: any, Secondindex: any) => (
                                      <>
                                        {AccessLevelData[2] &&
                                          AccessLevelData[2].map(
                                            (
                                              ThirdItem: any,
                                              Thirdindex: any
                                            ) => (
                                              <>
                                                {ThirdItem.ObjectID ==
                                                  SecondItem.ObjectID &&
                                                  ThirdItem.SiteUserID ==
                                                    FirstItem.SiteUserID && (
                                                    <>
                                                      <td>
                                                        <select
                                                          disabled={locked}
                                                          className="input-field select-field"
                                                          value={
                                                            ThirdItem.AccessStatus
                                                          }
                                                          onChange={(
                                                            e: any
                                                          ) => {
                                                            debugger;
                                                            updateValue(
                                                              e.target.value,
                                                              "AccessStatus",
                                                              FirstItem.Email,
                                                              2,
                                                              Thirdindex,
                                                              "access",
                                                              SecondItem.Name
                                                            );
                                                          }}
                                                        >
                                                          <option value={0}>
                                                            No
                                                          </option>
                                                          <option value={1}>
                                                           Yes
                                                          </option>                                                          
                                                        </select>
                                                      </td>
                                                    </>
                                                  )}
                                              </>
                                            )
                                          )}
                                      </>
                                    )
                                  )}
                              </tr>
                            )}
                          </React.Fragment>
                        )
                      )}
                  </tbody>
                </table>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default AccessLevel;
